import type { Fabric, FabricGroup } from '@susu/custom-made/utils/interfaces';

export enum actions {
  SELECT_FABRIC = 'SELECT_FABRIC',
  SELECT_FABRIC_GROUP = 'SELECT_FABRIC_GROUP',
}

export interface FabricStateProps {
  selectedFabric: Fabric | null;
  selectedFabricGroup: FabricGroup | null;
}

export const initialState: FabricStateProps = {
  selectedFabric: null,
  selectedFabricGroup: null,
};

interface SelectFabricAction {
  type: actions.SELECT_FABRIC;
  payload: Fabric;
}

interface SelectFabricGroupAction {
  type: actions.SELECT_FABRIC_GROUP;
  payload: FabricGroup;
}

export type FabricActionTypes = SelectFabricAction | SelectFabricGroupAction;

export default function FabricReducer(state: FabricStateProps, action: FabricActionTypes) {
  switch (action.type) {
    case actions.SELECT_FABRIC:
      return { ...state, selectedFabric: action.payload };
    case actions.SELECT_FABRIC_GROUP:
      return { ...state, selectedFabricGroup: action.payload };
    default:
      return state;
  }
}
